// EstadoConfig.js
const EstadoConfig = {
  5: {
    color: "#d32f2f",
    severity: "error",
    icon: "pi pi-bolt",
    label: "Alarma",
  },
  4: {
    color: "#FB8C00",
    severity: "warn",
    icon: "pi pi-exclamation-triangle",
    label: "Aviso",
  },
  3: {
    color: "#FDD835",
    severity: "warn",
    icon: "pi pi-exclamation-circle",
    label: "Precaución",
  },
  2: {
    color: "#388E3C",
    severity: "success",
    icon: "pi pi-check",
    label: "No Relámpago Detectado",
  },
  1: {
    color: "#757575",
    severity: "info",
    icon: "pi pi-info-circle",
    label: "Falla",
  },
};

export default EstadoConfig;
